import axios from "axios";
import { useEffect, useState } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import Box from "elements/Box";
import { Button, IconButton, Pagination, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import { Chip } from "@mui/material";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import TuneIcon from '@mui/icons-material/Tune';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { PiTruckLight, PiCalendarDotsLight } from "react-icons/pi";
import Filters2 from 'elements/Filters/Filters2';
import FiltersApplied2 from 'elements/Filters/FiltersApplied2';
import GuideDetailDialog from './GuideDetailDialog';

import "assets/css/main.css";

import { ApiRequest } from "GlobalFunctions";

export default function GuideRoutesList(props: any) {
  const { setLoading } = props;
  const { guide_id } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const guide_code = location.state?.guide_code || '';

  useEffect(() => {
    setLoading(false);
  }, []);

  const [list, setList] = useState<any[]>([]);
  const [totalPages, setTotalPages] = useState(0);
  const [page, setPage] = useState(1);
  const [filtersValues, setFiltersValues] = useState<any>([]);
  const [open, setOpen] = useState(false);
  const [guideVehicle, setGuideVehicle] = useState<string>('');
  const [guideDate, setGuideDate] = useState<string>('');
  const [detailOpen, setDetailOpen] = useState(false);
  const [selectedGuideId, setSelectedGuideId] = useState<number | null>(null);

  useEffect(() => {
    if (guide_id) {
      setLoading(true);
      loadList();
    }
  }, [page, filtersValues, guide_id]);

  const loadList = async () => {
    setLoading(true);

    await ApiRequest({
      url: '/guides/listv2',
      method: 'GET',
      query: {
        page: page,
        guide_id: guide_id,
        guide_code: guide_code,
        filters: filtersValues,
      },
      headers: {
        ltkn: localStorage.getItem("ltkn"),
      },
      setResponse: (response: any) => {
        setList(response.list);
        setTotalPages(response.total_pages);
        if (response.list && response.list.length > 0) {
          setGuideVehicle(response.list[0].license_plate || '-');
          setGuideDate(response.list[0].created_at || '-');
        }
        setLoading(false);
      }
    })
  };

  const filters = [
    { type: "select", label: "Estado", name: "status_id", value: "", options: [{label: "Todos", value: ""}, {label: "Pendiente", value: "0"}, {label: "Entregado", value: "2"}, {label: "Parcial", value: "3"}, {label: "Devuelto", value: "4"}] },
    { type: "text", label: "Nombre cliente", name: "client_name", value: "" },
    { type: "text", label: "Nombre negocio", name: "business_name", value: "" },
    { type: "text", label: "Código factura", name: "facture_code", value: "" },
  ];

  const setFilters = (tempFilters: any) => {
    setFiltersValues(tempFilters);
    localStorage.setItem('guideRoutesFilters', JSON.stringify(tempFilters));
  };

  return (
    <div id="GuideRoutesList" className="ModuleContainer">
      <div className="ModuleWrapper">
        <div className="boxContainerHeader">
          <div className="boxContainerTitle">
            <h2 className="h2_title">
              <IconButton 
                onClick={() => navigate('/guides')} 
                style={{ marginRight: '10px' }}
              >
                <ArrowBackIcon />
              </IconButton>
              Rutas de Guía {guide_code}
            </h2>
            <div style={{ display: 'flex', gap: '20px', marginTop: '5px' }}>
              <span className="h2_subtitle" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <PiTruckLight style={{ color: '#bdbdbd', fontSize: '1.2rem' }} />
                {guideVehicle}
              </span>
              <span className="h2_subtitle" style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
                <PiCalendarDotsLight style={{ color: '#bdbdbd', fontSize: '1.2rem' }} />
                {guideDate}
              </span>
            </div>
          </div>
          
          <div className='module_tools'>
            <Button
              variant="outlined"
              color="primary"
              startIcon={<TuneIcon />}
              onClick={() => setOpen(true)}
              style={{ marginRight: "10px" }}
            >
              Filtrar
            </Button>
          </div>
        </div>

        <Filters2 open={open} setOpen={setOpen} filters={filters} setFilters={setFilters} />
        <FiltersApplied2 filtersValues={filtersValues} setFiltersValues={setFiltersValues} filters={filters} />

        <Box id="GuideRoutesListIn" className="box100">
          <TableContainer>
            <Table aria-label="sticky table">
              <TableHead>
                <TableRow>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}>ID</TableCell>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}>Cliente</TableCell>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}>Factura</TableCell>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}>Valor</TableCell>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}>Recibido</TableCell>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}>Actualizado</TableCell>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none", textAlign: "center" }}>Estado</TableCell>
                  <TableCell sx={{ color: "#a8a8a8", borderBottom: "none" }}></TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {list.map((item, i) => (
                  <TableRow key={i} hover role="checkbox">
                    <TableCell>{item.client_guide_id}</TableCell>
                    <TableCell>
                      <span className='flex_title'>{item.business_name}</span>
                      <span className='flex_subtitle'>
                        {item.client_name} {item.client_name2} {item.client_last_name} {item.client_last_name2}
                      </span>
                    </TableCell>

                    <TableCell>
                      {item.facture_code}
                    </TableCell>

                    <TableCell>${item.guide_value?.toLocaleString()}</TableCell>

                    <TableCell>
                      {item.paid_amount > 0
                        ? `$${parseFloat(item.paid_amount).toLocaleString()}`
                        : '-'}
                    </TableCell>

                    <TableCell>{item.updated_at || '-'}</TableCell>

                    <TableCell align="center">
                      <Chip 
                        label={
                          item.status_id === 2 ? 'Entregado' :
                          item.status_id === 3 ? 'Parcial' :
                          item.status_id === 4 ? 'Devuelto' :
                          'Pendiente'
                        }
                        color={
                          item.status_id === 2 ? 'success' :
                          item.status_id === 3 ? 'warning' :
                          item.status_id === 4 ? 'error' :
                          'default'
                        }
                        size="small"
                      />
                    </TableCell>

                    <TableCell align="center">
                      <IconButton
                        size="small"
                        onClick={() => {
                          setSelectedGuideId(item.client_guide_id);
                          setDetailOpen(true);
                        }}
                      >
                        <InfoOutlinedIcon fontSize="small" />
                      </IconButton>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
          <Pagination
            count={totalPages}
            page={page}
            onChange={(event, value) => setPage(value)}
            color="primary"
            style={{ marginTop: "20px", alignSelf: "center" }}
          />
        </Box>
      </div>

      <GuideDetailDialog
        open={detailOpen}
        onClose={() => setDetailOpen(false)}
        client_guide_id={selectedGuideId}
      />
    </div>
  );
}
